import { Component, computed, input, model, output } from '@angular/core';
import { dateToString } from '@agilox/common';
import { CalendarWeekOutput } from '@agilox/ui-common';

/**
 * This component wraps the navigation and the calendar
 * Is used both by the INLINE and the INPUT datepicker variants
 */
@Component({
	selector: 'ui-datepicker-base',
	templateUrl: './datepicker-base.component.html',
	standalone: false,
})
export class DatepickerBaseComponent {
	currentlyDisplayedMonth = model.required<Date>();

	currentlyDisplayedMonthVal = computed(() => {
		const minDate = this.minDate();
		const maxDate = this.maxDate();
		if (minDate && this.currentlyDisplayedMonth() < minDate) {
			return new Date(minDate);
		}
		if (maxDate && this.currentlyDisplayedMonth() > maxDate) {
			return new Date(maxDate);
		}
		return this.currentlyDisplayedMonth();
	});

	minDate = input<Date | undefined>(undefined);
	maxDate = input<Date | undefined>(undefined);
	disabled = input<boolean>(true);
	selectedDate = input<string | null>(null);
	syncedDate = input<Date | undefined>(undefined);
	excludedDates = input<Date[]>([]);

	dateSelectionChange = output<string>();
	navDateChange = output<Date>();
	calendarWeekClicked = output<CalendarWeekOutput>();

	public onTodayClick(): void {
		const today = new Date();
		this.currentlyDisplayedMonth.set(today);
		this.dateSelectionChange.emit(dateToString(today));
	}
}
